export default (record) => {
  if (!record?.contract_worked_time) return 0;
  const array = record?.contract_worked_time?.split(':');
  return array ? parseFloat(array[0]) + parseFloat(array[1]) / 60 : 0;
};
